
const GLOBAL_VARIABLE = {
  OSSURL: 'http://oss.jybhls.com/'
};

export default GLOBAL_VARIABLE


// WEBPACK FOOTER //
// ./src/utils/global_variable.js